export default {"src":"/_next/static/media/icon-marketplace-planet.fa244ae6.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};